exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container img {\n  border-radius: 50%;\n  object-fit: cover;\n  object-position: center;\n}\n", ""]);

// exports
